module.exports = __webpack_public_path__ + "media/images/bullet-bg-e7ddb951df8fc1b6c9b45924469ca04d.svg";